module.exports = __webpack_public_path__ + "img/mind_template_item_2_6.edb6c435.png";